import { LiteralValue } from './LiteralValue';

export class BooleanValue extends LiteralValue<boolean> {}
